import { default as _91id_93gdkKnLYsGLMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/attachments/[id].vue?macro=true";
import { default as index57DlmJxn77Meta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/blowing-machine/index.vue?macro=true";
import { default as indexTIqf9jqPtPMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/bottle-production/index.vue?macro=true";
import { default as index8md2gVFGwiMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/bucket-production/index.vue?macro=true";
import { default as indexYPJzusYFOOMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/complaints/index.vue?macro=true";
import { default as indexnV7LcsK7CUMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/index.vue?macro=true";
import { default as indexMWn8SSQZoJMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/legal-notice/index.vue?macro=true";
import { default as indexZ64Q8YSQNwMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/privacy/index.vue?macro=true";
import { default as indexB73jIYidIFMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/tenders/index.vue?macro=true";
import { default as _91id_93TQDFegMhdeMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/accesorios/[id].vue?macro=true";
import { default as indexFxIIesv8yFMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/aviso-legal/index.vue?macro=true";
import { default as indexNv0ZqZ1yVPMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/botellas/index.vue?macro=true";
import { default as index1pEcuxCTXsMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/cucharas/index.vue?macro=true";
import { default as indexuNycYeSBHDMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/datos/index.vue?macro=true";
import { default as indexNy3MQ53RKQMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/index.vue?macro=true";
import { default as indexz8Zkg6RgGnMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/licitaciones/index.vue?macro=true";
import { default as indexGUcPreDLslMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/maquinas-de-soplado-de-botellas/index.vue?macro=true";
import { default as indexr9NuFQISzHMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/quejas/index.vue?macro=true";
import { default as indexncU2YKEcNEMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/adatvedelem/index.vue?macro=true";
import { default as indexMQ3vzV7FxXMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/bermunka/index.vue?macro=true";
import { default as indexcCdOZdStWoMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/flakonfuvo-gepgyartas/index.vue?macro=true";
import { default as indexsLVPREqi09Meta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/flakongyartas/index.vue?macro=true";
import { default as index1QQjowHsQoMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/impresszum/index.vue?macro=true";
import { default as indexgXN7oJJjQBMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/index.vue?macro=true";
import { default as indexdUbRnXtVGgMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/kanalgyartas/index.vue?macro=true";
import { default as indexjb4QfNgUTiMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/palyazatok/index.vue?macro=true";
import { default as indexGZTOSpO8ueMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/panaszkezeles/index.vue?macro=true";
import { default as _91id_93TLZU6RaxDKMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/szerelekek/[id].vue?macro=true";
import { default as index0EuprTtpz1Meta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/index.vue?macro=true";
import { default as _91id_93ToTvZCtu82Meta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/accesorii/[id].vue?macro=true";
import { default as indexVm6Q9wiiaXMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/cupe/index.vue?macro=true";
import { default as indexz8D71JDc6YMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/datelor/index.vue?macro=true";
import { default as index4iZIUjlRQhMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/flacoane/index.vue?macro=true";
import { default as indexiVeKoRHzvkMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/index.vue?macro=true";
import { default as indexePljk8uZ9bMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/licitatii/index.vue?macro=true";
import { default as indexbLCKb4EXEhMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/masini-de-suflat-flacoane/index.vue?macro=true";
import { default as indexi5yNe0sGRfMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/nota-legala/index.vue?macro=true";
import { default as index6SCGrqZ3SsMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/plangeri/index.vue?macro=true";
import { default as index8Pe00THCEcMeta } from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/thanks/index.vue?macro=true";
export default [
  {
    name: "en-attachments-id",
    path: "/en/attachments/:id()",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/attachments/[id].vue").then(m => m.default || m)
  },
  {
    name: "en-blowing-machine",
    path: "/en/blowing-machine",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/blowing-machine/index.vue").then(m => m.default || m)
  },
  {
    name: "en-bottle-production",
    path: "/en/bottle-production",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/bottle-production/index.vue").then(m => m.default || m)
  },
  {
    name: "en-bucket-production",
    path: "/en/bucket-production",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/bucket-production/index.vue").then(m => m.default || m)
  },
  {
    name: "en-complaints",
    path: "/en/complaints",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/complaints/index.vue").then(m => m.default || m)
  },
  {
    name: "en",
    path: "/en",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/index.vue").then(m => m.default || m)
  },
  {
    name: "en-legal-notice",
    path: "/en/legal-notice",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/legal-notice/index.vue").then(m => m.default || m)
  },
  {
    name: "en-privacy",
    path: "/en/privacy",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/privacy/index.vue").then(m => m.default || m)
  },
  {
    name: "en-tenders",
    path: "/en/tenders",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/en/tenders/index.vue").then(m => m.default || m)
  },
  {
    name: "es-accesorios-id",
    path: "/es/accesorios/:id()",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/accesorios/[id].vue").then(m => m.default || m)
  },
  {
    name: "es-aviso-legal",
    path: "/es/aviso-legal",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/aviso-legal/index.vue").then(m => m.default || m)
  },
  {
    name: "es-botellas",
    path: "/es/botellas",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/botellas/index.vue").then(m => m.default || m)
  },
  {
    name: "es-cucharas",
    path: "/es/cucharas",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/cucharas/index.vue").then(m => m.default || m)
  },
  {
    name: "es-datos",
    path: "/es/datos",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/datos/index.vue").then(m => m.default || m)
  },
  {
    name: "es",
    path: "/es",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/index.vue").then(m => m.default || m)
  },
  {
    name: "es-licitaciones",
    path: "/es/licitaciones",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/licitaciones/index.vue").then(m => m.default || m)
  },
  {
    name: "es-maquinas-de-soplado-de-botellas",
    path: "/es/maquinas-de-soplado-de-botellas",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/maquinas-de-soplado-de-botellas/index.vue").then(m => m.default || m)
  },
  {
    name: "es-quejas",
    path: "/es/quejas",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/es/quejas/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-adatvedelem",
    path: "/hu/adatvedelem",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/adatvedelem/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-bermunka",
    path: "/hu/bermunka",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/bermunka/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-flakonfuvo-gepgyartas",
    path: "/hu/flakonfuvo-gepgyartas",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/flakonfuvo-gepgyartas/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-flakongyartas",
    path: "/hu/flakongyartas",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/flakongyartas/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-impresszum",
    path: "/hu/impresszum",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/impresszum/index.vue").then(m => m.default || m)
  },
  {
    name: "hu",
    path: "/hu",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-kanalgyartas",
    path: "/hu/kanalgyartas",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/kanalgyartas/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-palyazatok",
    path: "/hu/palyazatok",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/palyazatok/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-panaszkezeles",
    path: "/hu/panaszkezeles",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/panaszkezeles/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-szerelekek-id",
    path: "/hu/szerelekek/:id()",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/hu/szerelekek/[id].vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-accesorii-id",
    path: "/ro/accesorii/:id()",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/accesorii/[id].vue").then(m => m.default || m)
  },
  {
    name: "ro-cupe",
    path: "/ro/cupe",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/cupe/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-datelor",
    path: "/ro/datelor",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/datelor/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-flacoane",
    path: "/ro/flacoane",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/flacoane/index.vue").then(m => m.default || m)
  },
  {
    name: "ro",
    path: "/ro",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-licitatii",
    path: "/ro/licitatii",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/licitatii/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-masini-de-suflat-flacoane",
    path: "/ro/masini-de-suflat-flacoane",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/masini-de-suflat-flacoane/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-nota-legala",
    path: "/ro/nota-legala",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/nota-legala/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-plangeri",
    path: "/ro/plangeri",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/ro/plangeri/index.vue").then(m => m.default || m)
  },
  {
    name: "thanks",
    path: "/thanks",
    component: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/pages/thanks/index.vue").then(m => m.default || m)
  }
]